import axios from 'axios'

const BASE = process.env.REACT_APP_HOST_API + '/study'

export const getConfig = () => axios.get(`${BASE}/config`).then(r => r.data)

// Invite-token redemption — creates the participant's account on first use and
// re-attaches to it thereafter. Returns { user, token (JWT), participantId }.
export const redeem = (token) => axios.post(`${BASE}/redeem`, { token }).then(r => r.data)

export const login = (participantId) => axios.post(`${BASE}/login`, { participantId }).then(r => r.data)
export const getCurrent = (participantId) => axios.get(`${BASE}/current`, { params: { participantId } }).then(r => r.data)
export const getFollowup = (participantId) => axios.get(`${BASE}/followup/current`, { params: { participantId } }).then(r => r.data)
export const advance = (participantId, payload, reason = 'complete') =>
  axios.post(`${BASE}/advance`, { participantId, payload, reason }).then(r => r.data)
export const getBookingOptions = (participantId) =>
  axios.get(`${BASE}/booking/options`, { params: { participantId } }).then(r => r.data)
export const book = (participantId, slotISO) =>
  axios.post(`${BASE}/book`, { participantId, slotISO }).then(r => r.data)

// Buffered telemetry batch, flushed every 5s. The server writes it to the JSONL
// store and to the Postgres telemetry_events table. Events go over the wire in the
// same { type, payload, timestamp } envelope /workspace stores, plus stepId; the
// client `timestamp` is authoritative, since the server's receive time would
// collapse a whole batch of 50ms-resolution MOUSE_MOVEs onto one instant.
export const postTelemetryBatch = (participantId, events) =>
  axios.post(`${BASE}/telemetry`, {
    participantId,
    events: events.map(e => ({
      type: e.type,
      payload: e.payload,
      timestamp: e.timestamp,
      stepId: e.stepId
    }))
  }).then(r => r.data)

// admin (test-mode only)
export const adminList = () => axios.get(`${BASE}/admin/list`).then(r => r.data)
export const adminForceAdvance = (participantId) => axios.post(`${BASE}/admin/force-advance`, { participantId }).then(r => r.data)
export const adminReset = (participantId) => axios.post(`${BASE}/admin/reset`, { participantId }).then(r => r.data)
export const adminOpenFollowup = (participantId) => axios.post(`${BASE}/admin/open-followup`, { participantId }).then(r => r.data)
// Test-mode jump to a part. Moves the server's phase pointer — plain navigation can't,
// since the phase URLs follow that pointer rather than setting it.
export const adminSetPhase = (participantId, phase) =>
  axios.post(`${BASE}/admin/phase`, { participantId, phase }).then(r => r.data)
// Same endpoint the replay dashboard's eligibility buttons use. Mirrored onto the test
// bar so a dry run can go screening → main without switching to the dashboard mid-walk.
export const adminRelease = (participantId) =>
  axios.post(`${BASE}/admin/eligibility`, { participantId, eligibility: 'eligible' }).then(r => r.data)

// TEMPORARY: back/next buttons. Moves the step pointer without recording an answer —
// see the backend's engine.step. Remove alongside StudyNav.jsx.
export const navStep = (participantId, delta) =>
  axios.post(`${BASE}/nav`, { participantId, delta }).then(r => r.data)
